// --------------------- Import Antd-Design ---------------------
import { Skeleton, Button, Flex } from "antd";
// --------------------- Import Hooks ---------------------
import { usePermissao } from "../../uteis/permissaoAdm/usePermissao";
// --------------------- Import React ---------------------
import { NumberParam, useQueryParams } from "use-query-params";
import { useState } from "react";
// --------------------- Import Styles ---------------------
import { buttonStyle, TitleIndex } from "./styles";
// --------------------- Import Modal ---------------------
import ModalCadastroInicial from "./components/ModalCadastroInicial";
import ModalValidacaoProprietario from "./components/ModalValidacaoProprietario";
import ModalConfiguracaoPropriedade from "./components/ModalConfiguracaoPropriedade";
import ModalAnuncioPropriedade from "./components/ModalAnuncioPropriedade";

export default function ViewGerenciarPropriedadeUsuario() {
  // Resgata a cota usuario enviada via URL
  const [query] = useQueryParams({
    cotaUsuarioId: NumberParam,
  });
  const cotaUsuarioId = query.cotaUsuarioId;

  // Verificação de usuário caso seja ADM
  const { isLoading: isTokenLoading, isValid } = usePermissao("OPE");

  // State para armazenar o modal ativo
  const [modalAtivo, setModalAtivo] = useState<string | null>(null);

  // Função para abrir um modal específico
  const abrirModal = (modalName: string | null) => {
    setModalAtivo(modalName);
  };

  // Função para fechar o modal
  const fecharModal = () => {
    setModalAtivo(null);
  };
  return (
    <>
      {isTokenLoading || !isValid ? (
        <Skeleton active />
      ) : (
        <Flex
          vertical
          gap="small"
          style={{
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
            height: "50vh", // Para centralizar verticalmente
          }}
        >
          <TitleIndex>Editar Propriedade do Usuário</TitleIndex>
          <Button
            onClick={() => abrirModal("CadastroInicial")}
            style={buttonStyle}
          >
            Cadastro Inicial
          </Button>
          <Button
            onClick={() => abrirModal("ValidacaoProprietario")}
            style={buttonStyle}
          >
            Validação de Proprietário
          </Button>
          <Button
            onClick={() => abrirModal("ConfiguracaoPropriedade")}
            style={buttonStyle}
          >
            Configuração de Propriedade
          </Button>
          <Button
            onClick={() => abrirModal("AnuncioPropriedade")}
            style={buttonStyle}
          >
            Anúncio de Venda
          </Button>

          {modalAtivo === "CadastroInicial" && (
            <ModalCadastroInicial
              isModalOpen={!!modalAtivo}
              handleFechar={fecharModal}
              cotaUsuarioId={cotaUsuarioId}
            />
          )}
          {modalAtivo === "ValidacaoProprietario" && (
            <ModalValidacaoProprietario
              isModalOpen={!!modalAtivo}
              handleFechar={fecharModal}
              cotaUsuarioId={cotaUsuarioId}
            />
          )}
          {modalAtivo === "ConfiguracaoPropriedade" && (
            <ModalConfiguracaoPropriedade
              isModalOpen={!!modalAtivo}
              handleFechar={fecharModal}
              cotaUsuarioId={cotaUsuarioId}
            />
          )}
          {modalAtivo === "AnuncioPropriedade" && (
            <ModalAnuncioPropriedade
              isModalOpen={!!modalAtivo}
              handleFechar={fecharModal}
              cotaUsuarioId={cotaUsuarioId}
            />
          )}
        </Flex>
      )}
    </>
  );
}
